import PropTypes from "prop-types";

import { Rect, Circle, Icon } from "./Today.styles";

const Today = ({
    size,
    hover,
    disabled,
    rectStrokeColor,
    circleStrokeColor,
    circleFillColor,
    rectStrokeHoverColor,
    circleStrokeHoverColor,
    circleFillHoverColor,
}) => {
    return (
        <Icon
            width={size}
            height={size}
            viewBox={"0 0 18 18"}
            xmlns="http://www.w3.org/2000/svg"
            hover={hover}
            disabled={disabled}
            rectStrokeHoverColor={rectStrokeHoverColor}
            circleStrokeHoverColor={circleStrokeHoverColor}
            circleFillHoverColor={circleFillHoverColor}
        >
            <Circle
                color={circleStrokeColor}
                fill={circleFillColor}
                r="8.415"
                transform="matrix(-1 0 0 1 9 9)"
                strokeWidth="1.17"
            />
            <Rect
                x="9"
                y="5.82719"
                width="4.83"
                height="4.83"
                transform="rotate(45 9 5.82719)"
                color={rectStrokeColor}
                strokeWidth="1.17"
            />
        </Icon>
    );
};

Today.defaultProps = {
    size: "18",
    hover: false,
    rectStrokeColor: globalThis.config.colors.black,
    rectStrokeHoverColor: globalThis.config.colors.black,
    circleStrokeColor: globalThis.config.colors.gray6,
    circleStrokeHoverColor: globalThis.config.colors.gray6,
    circleFillColor: "transparent",
    circleFillHoverColor: globalThis.config.colors.gray7,
    disabled: false,
};

Today.propTypes = {
    size: PropTypes.string,
    hover: PropTypes.bool,
    rectStrokeColor: PropTypes.string,
    rectStrokeHoverColor: PropTypes.string,
    circleStrokeColor: PropTypes.string,
    circleStrokeHoverColor: PropTypes.string,
    circleFillColor: PropTypes.string,
    circleFillHoverColor: PropTypes.string,
    disabled: PropTypes.bool,
};

export default Today;
